var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOtp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 27,
    viewBox: "0 0 18 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.56217 16.7805V15.0151H12.6237V16.7805H5.56217ZM4.38525 13.2498V11.4844H13.8006V13.2498H4.38525ZM3.20833 26.7843C2.56103 26.7843 2.00689 26.5539 1.54593 26.0929C1.08497 25.6319 0.854492 25.0778 0.854492 24.4305V3.24593C0.854492 2.59862 1.08497 2.04449 1.54593 1.58353C2.00689 1.12257 2.56103 0.89209 3.20833 0.89209H14.9775C15.6248 0.89209 16.179 1.12257 16.6399 1.58353C17.1009 2.04449 17.3314 2.59862 17.3314 3.24593V24.4305C17.3314 25.0778 17.1009 25.6319 16.6399 26.0929C16.179 26.5539 15.6248 26.7843 14.9775 26.7843H3.20833ZM3.20833 23.2536V24.4305H14.9775V23.2536H3.20833ZM3.20833 20.8997H14.9775V6.77669H3.20833V20.8997ZM3.20833 4.42285H14.9775V3.24593H3.20833V4.42285Z",
    fill: "#1BA397"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtp);
export default __webpack_public_path__ + "static/media/otp.4c83000bbf047af05ae671d32df93ba3.svg";
export { ForwardRef as ReactComponent };